import { render, staticRenderFns } from "./SaleReceiptComponent.vue?vue&type=template&id=589a083e&scoped=true"
import script from "./SaleReceiptComponent.vue?vue&type=script&lang=js"
export * from "./SaleReceiptComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589a083e",
  null
  
)

export default component.exports